import React from 'react';
import { observer } from 'mobx-react';
import AddDeviceTableComponent from './Add-device-table.component';
import useAddDeviceTable from './useAddDeviceTable';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { devices, lang, state, handlers } = useAddDeviceTable(onClose);

    return (
        <>
            <AddDeviceTableComponent
                loading={state.loading}
                lang={lang.lang}
                page={state.page}
                limit={state.limit}
                rows={state.rows}
                columns={state.columns}
                uploadError={state.uploadError}
                errorMap={state.errorMap}
                imeiNotExistError={devices.imeiNotExistError}
                noRightsError={devices.noRightsError}
                wrongPasswordError={devices.wrongPasswordError}
                onPageChange={handlers.handlePageChange}
                onCancelClick={handlers.handleCancelClick}
                onAddClick={handlers.handleAddClick}
                onCellEditStart={handlers.handleCellEditStart}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onLimitChange={handlers.handeLimitChange}
                onClose={onClose}
            />
        </>
    );
};

const AddDeviceTableContainer = observer(Container);

export default AddDeviceTableContainer;
